import { useTranslation } from 'react-i18next'
import { GlobalContentContainer, MainInnerButton, SectionTitle, SectionText } from '../../../App.styled'
import List from '../../List'
import {
  Section,
  SectionContainer,
  SectionContent,
} from './styled'

import routesPaths from '../../../routes/routesPaths'

import travelImg from '../../../images/main-page/travaling.jpg'

const firstList = (t) => [
  t('PAGE_MAIN.INVESTMENTS.LIST_1'),
  t('PAGE_MAIN.INVESTMENTS.LIST_2')
]
const secondList = (t) => [
  t('PAGE_MAIN.INVESTMENTS.LIST_3'), 
  t('PAGE_MAIN.INVESTMENTS.LIST_4'), 
  t('PAGE_MAIN.INVESTMENTS.LIST_5')
]

const InvestmentsSection = () => {
  const { t } = useTranslation()

  return (
    <Section>
      <GlobalContentContainer>
        <SectionContainer>
          <SectionContent>
            <img src={travelImg} alt=""/>

            <SectionText hasMargin>{t('PAGE_MAIN.INVESTMENTS.TEXT')}</SectionText>
          
            <List list={firstList(t)} />
          </SectionContent>

          <SectionContent>
            <SectionTitle>{t('PAGE_MAIN.INVESTMENTS')}</SectionTitle>

            <SectionText hasMargin>{t('PAGE_MAIN.INVESTMENTS.TEXT_2')}</SectionText>

            <List list={secondList(t)} />

            <MainInnerButton to={routesPaths.cards}>{t('GLOBAL.CHOOSE_CARD')}</MainInnerButton>
          </SectionContent>
        </SectionContainer>
      </GlobalContentContainer>
    </Section>
  )
}

export default InvestmentsSection
